import module from '@kendu/ui/module'

export class KdInputComponent {}

module.directive('kdInput', () => ({
  controller: KdInputComponent,
  restrict: 'A',
  require: {
    kdControl: '^kdControl',
  },
  link (scope, element, attrs, ctrl) {
    ctrl.kdControl.setLabel(attrs.placeholder || '')

    attrs.$set('placeholder', '')

    attrs.$addClass('kd-input')

    attrs.$observe('required', (required) => {
      ctrl.kdControl.setRequired(required)
    })
  },
}))



// WEBPACK FOOTER //
// ./src/kendu/ui/directives/kd-input/directive.js